import { useEffect, useState } from 'react';
import { CaretLeftIcon, CaretRightIcon, MagnifyingGlassIcon } from '@phosphor-icons/react';

import { Breadcrumb } from '../../../../../components/Breadcrumb';
import { PageHeader } from '../../../../../components/PageHeader';
import { CustomerSelect } from './CustomerSelect';
import { CreateIncassoProvider, useCreateIncassoCtx } from './context';
import { Button } from '../../../../../components/button/Button';
import { InvoiceSelect } from './InvoiceSelect';
import { Input } from '../../../../../components/input/Input';
import { PageHeading } from 'components/PageHeading';
import { IncassoCreationOverview } from './Overview';

const CreateIncassoComponent = () => {
  const { state, dispatch } = useCreateIncassoCtx();
  const [searchValue, setSearchValue] = useState('');

  let title = '';
  switch (state.activeWindow) {
    case 'SELECT_CUSTOMER':
      title = 'Selecteer een klant';
      break;
    case 'SELECT_INVOICES':
      title = 'Selecteer facturen';
      break;
  }

  let canGoForward = false;
  if (state.activeWindow === 'SELECT_CUSTOMER') {
    canGoForward = state.selectedCustomer !== null;
  } else if (state.activeWindow === 'SELECT_INVOICES') {
    canGoForward = state.selectedInvoices.length > 0;
  }

  useEffect(() => {
    setSearchValue('');
  }, [state.activeWindow]);

  let searchText = 'search';
  switch (state.activeWindow) {
    case 'SELECT_CUSTOMER':
      searchText = 'Zoek een klant';
      break;
    case 'SELECT_INVOICES':
      searchText = 'Zoek een factuur';
      break;
  }

  return (
    <>
      <PageHeader title="Nieuwe incasso" />

      <PageHeading
        leftSide={
          <Breadcrumb
            parentItem={{
              name: 'incassos',
              to: '/internal/finance/incasso',
            }}
            currentItem="Nieuwe incasso"
          />
        }
      />

      <div className="flex justify-between mb-4 px-4">
        <h2 className="heading-two self-start">{title}</h2>

        <div className="flex gap-4">
          <div>
            <Button
              iconLeft={<CaretLeftIcon className="button-icon" />}
              isDisabled={state.activeWindow === 'SELECT_CUSTOMER'}
              onTrigger={() => {
                dispatch({
                  type: 'GO_BACK',
                });
              }}
            >
              Keer terug
            </Button>
          </div>

          <div>
            <Button
              color="primary"
              iconRight={<CaretRightIcon className="button-icon" />}
              isDisabled={!canGoForward}
              onTrigger={() => {
                dispatch({
                  type: 'GO_FORWARD',
                });
              }}
            >
              Ga verder
            </Button>
          </div>
        </div>
      </div>

      <div className="px-4">
        {state.activeWindow !== 'OVERVIEW' && (
          <div className="mb-4">
            <Input
              type="text"
              placeholder={searchText}
              value={searchValue}
              onChange={setSearchValue}
              iconLeft={<MagnifyingGlassIcon className="input-icon" />}
            />
          </div>
        )}

        {state.activeWindow === 'SELECT_CUSTOMER' && <CustomerSelect searchValue={searchValue} />}
        {state.activeWindow === 'SELECT_INVOICES' && <InvoiceSelect searchValue={searchValue} />}
        {state.activeWindow === 'OVERVIEW' && <IncassoCreationOverview />}
      </div>
    </>
  );
};

const CreateIncassoPage = () => {
  return (
    <CreateIncassoProvider>
      <CreateIncassoComponent />
    </CreateIncassoProvider>
  );
};

export default CreateIncassoPage;
